import { render, staticRenderFns } from "./HistoryManage.vue?vue&type=template&id=aefb1b48&scoped=true&"
import script from "./HistoryManage.vue?vue&type=script&lang=js&"
export * from "./HistoryManage.vue?vue&type=script&lang=js&"
import style0 from "./HistoryManage.vue?vue&type=style&index=0&id=aefb1b48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefb1b48",
  null
  
)

export default component.exports